/**
 * Removes file extension from a URL path
 * @example
 * // returns 'dog'
 * removeFileExtension('dog.jpg');
 * @example
 * // returns 'a.b.c/dog'
 * removeFileExtension('a.b.c/dog.jpg');
 */
export const removeFileExtension = (path: string) => {
  const segments = path.split('/');

  const initialSegments = segments.slice(0, -1);
  const lastSegment = segments.slice(-1)[0];

  // removes extension from the last segment of the path
  const filename = lastSegment.split('.').slice(0, -1).join('.') || lastSegment;

  return [...initialSegments, filename].join('/');
};
